<template>
    <div class="container-fluid p-3">
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-column">
                <div class="title d-flex align-items-center">
                    <inline-svg class="me-2" width="36" height="36" src="/assets/img/icons/face-smile.svg"></inline-svg>
                    Heroes
                </div>
                <div class="subtitle">See and manage your Heroes | <strong>Each Hero needs a MagnusCards account</strong></div>
            </div>
            <div class="d-flex flex-column">
                <btn class="btn btn-primary" @click="$modal.show('addHeroModal')">
                    <inline-svg class="me-1" src="/assets/img/icons/plus.svg"></inline-svg>
                    Add a Hero
                </btn>
            </div>
        </div>
        <div class="mt-3">
            <heroes-table></heroes-table>
        </div>
        <modal name="addHeroModal" height="auto" width="500px" :scrollable="true" @before-open="clearInput">
            <div class="modal-content">
                <div class="modal-header d-flex flex-column">
                    <div class="w-100 text-center" style="position: relative">
                        <h4 class="modal-title">Add a Hero</h4>
                        <button type="button" class="btn-close btn-close-absolute" data-dismiss="modal" aria-hidden="true"
                                @click="$modal.hide('addHeroModal')"></button>
                    </div>
                    <div class="modal-subtitle-gray">Connect to a Hero by entering the email used for their MagnusCards account.</div>
                </div>
                <div class="modal-body">
                    <form-input placeholder="Enter Hero email"
                                type="email"
                                :v="$v.heroEmail"
                                v-model="heroEmail">
                    </form-input>
                    <div class="modal-subtitle-gray">Your Hero needs a MagnusCards account to be added.</div>
                </div>
                <div class="divider --top-12"></div>
                <div class="d-flex flex-row justify-content-between gap-2" style="padding: 24px">
                    <btn class="btn-outline-light btn-lg flex-1" @click="$modal.hide('addHeroModal')">Cancel</btn>
                    <btn class="btn-primary btn-lg flex-1"
                         :class="{'loading': loading.add }"
                         :disabled="!heroEmail"
                         @click="addHero()">Add
                    </btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

import HeroesTable from "@/components/HeroesTable.vue";
import HeroSelect from "@/components/HeroSelect.vue";
const {required, email} = require('vuelidate/lib/validators');

export default {
    name: 'Heroes',
    components: {HeroSelect, HeroesTable},
    data() {
        return {
            loading: {
                add: false,
            },
            heroEmail: ''
        };
    },
    validations: {
        heroEmail: {required, email}
    },
    methods: {
        addHero() {
            this.$v.heroEmail.$touch();
            if (this.$v.heroEmail.$invalid === true) {
                return false;
            }
            this.loading.add = true;
            this.$http.post("/hero/add", {email: this.heroEmail})
                .then((res) => {
                    this.$events.emit('loadHeroes');
                    this.loading.add = false;
                    this.$modal.hide('addHeroModal');
                })
                .catch((error) => {
                    this.loading.add = false;
                });
        },
        clearInput() {
            this.heroEmail = '';
        }
    },
};
</script>
